import mixpanel from "mixpanel-browser"
import { DIAGNOSES_EVENTS } from "."

interface CreateDiagnosisProps {
  creationDate: string
  userName: string
  userEmail: string
}

export function createDiagnosis(props: CreateDiagnosisProps) {
  return mixpanel.track(DIAGNOSES_EVENTS.CREATE_DIAGNOSIS, {
    ...props,
  })
}
